"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = exports.UnstyledPanel = void 0;
var clsx_1 = __importDefault(require("clsx"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var Icon_1 = require("../Icon");
var IconButton_1 = require("../IconButton");
var IconMenu_1 = require("../IconMenu");
var ListItemText_1 = require("../ListItemText");
var MenuItem_1 = require("../MenuItem");
var Paper_1 = require("../Paper");
var styles_1 = require("../styles");
var Tooltip_1 = require("../Tooltip");
var Typography_1 = require("../Typography");
var styles = function (theme) { return ({
    root: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        // border: `1px solid ${theme.palette.divider}`,
        height: '100%',
        background: theme.palette.background.default,
        boxShadow: theme.shadows[4],
        '& > *': {
            boxSizing: 'border-box',
        },
    },
    dense: {
        '& $header': {
            flexBasis: "".concat(theme.spacing(4), "px"),
        },
        '& $headerBig': {
            flexBasis: "".concat(theme.spacing(8), "px"),
        },
    },
    header: {
        flex: "0 0 ".concat(theme.spacing(5), "px"),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: theme.shadows[4],
        // Ensure panel header is above content
        zIndex: 100,
    },
    headerBig: {
        flex: "0 0 ".concat(theme.spacing(10), "px"),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& $titlesContainer': {
            alignItems: 'flex-start',
        },
        '& $titles': {
            paddingLeft: theme.spacing(2),
        },
        '& $actions': {
            alignSelf: 'flex-start',
        },
    },
    headerDark: {
        color: theme.palette.common.white,
        background: theme.palette.grey[700],
    },
    headerLight: {
        color: theme.palette.text.primary,
        background: theme.palette.grey[200],
    },
    titlesContainer: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
    },
    hasClickHandler: {
        cursor: 'pointer',
    },
    titlesContainerWithIcon: {
        paddingLeft: theme.spacing(1),
    },
    titleIcon: {
        flex: '0 0 auto',
    },
    titles: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: theme.spacing(1),
        overflow: 'hidden',
    },
    title: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    subTitle: {
        textTransform: 'none',
        fontWeight: '200',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    actions: {
        display: 'flex',
    },
    actionBtn: {
        color: 'inherit',
    },
    actionBtnDark: {
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.08)',
        },
    },
    body: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
    },
}); };
var UnstyledPanel = function (_a) {
    var _b, _c, _d;
    var classes = _a.classes, titleIcon = _a.titleIcon, titleIconTooltipText = _a.titleIconTooltipText, title = _a.title, subTitle = _a.subTitle, variant = _a.variant, dense = _a.dense, headerActions = _a.headerActions, onTitleContainerClick = _a.onTitleContainerClick, actionIcons = _a.actionIcons, menuOptions = _a.menuOptions, children = _a.children, dataTestId = _a.dataTestId, headerTestId = _a.headerTestId;
    var menuItems = function (closeMenuHandler) {
        return menuOptions.map(function (item, index) {
            return (react_1.default.createElement(MenuItem_1.MenuItem, { key: index, onClick: closeMenuHandler(item.onClick), dense: true },
                react_1.default.createElement(ListItemText_1.ListItemText, { primary: item.label })));
        });
    };
    return (react_1.default.createElement(Paper_1.Paper, { className: (0, clsx_1.default)(classes.root, (_b = {},
            _b[classes.dense] = dense,
            _b)), elevation: 0, square: true },
        react_1.default.createElement("header", { className: (0, clsx_1.default)((_c = {},
                _c[classes.header] = subTitle === null,
                _c[classes.headerBig] = subTitle !== null,
                _c[classes.headerDark] = variant === 'dark',
                _c[classes.headerLight] = variant === 'light',
                _c)), "data-testid": headerTestId },
            react_1.default.createElement("div", { className: (0, clsx_1.default)(classes.titlesContainer, (_d = {},
                    _d[classes.titlesContainerWithIcon] = titleIcon !== null,
                    _d[classes.hasClickHandler] = onTitleContainerClick !== null,
                    _d)), onClick: onTitleContainerClick },
                titleIcon !== null && (react_1.default.createElement(Tooltip_1.Tooltip, { className: classes.titleIcon, title: titleIconTooltipText }, titleIcon)),
                title !== null && (react_1.default.createElement("div", { className: classes.titles },
                    react_1.default.createElement(Typography_1.Typography, { className: classes.title, variant: subTitle !== null ? 'h6' : 'subtitle2', color: "inherit", gutterBottom: false }, title),
                    subTitle !== null && (react_1.default.createElement(Typography_1.Typography, { className: classes.subTitle, variant: "subtitle2", color: "inherit" }, subTitle))))),
            react_1.default.createElement("div", { className: classes.actions },
                headerActions !== null && headerActions,
                headerActions === null &&
                    actionIcons.length !== 0 &&
                    actionIcons.map(function (btn) {
                        var _a;
                        return (react_1.default.createElement(IconButton_1.IconButton, { className: (0, clsx_1.default)(classes.actionBtn, (_a = {},
                                _a[classes.actionBtnDark] = variant === 'dark',
                                _a)), key: btn.icon, onClick: btn.onClick },
                            react_1.default.createElement(Icon_1.Icon, null, btn.icon)));
                    }),
                headerActions === null &&
                    menuOptions.length !== 0 && (react_1.default.createElement("div", { className: classes.iconMenu },
                    react_1.default.createElement(IconMenu_1.IconMenu, { variant: variant === 'dark' ? 'light' : 'dark', renderItems: menuItems }))))),
        react_1.default.createElement("div", { className: classes.body, "data-testid": dataTestId }, children)));
};
exports.UnstyledPanel = UnstyledPanel;
exports.UnstyledPanel.propTypes = {
    /** Icon that appears left of the title text */
    titleIcon: prop_types_1.default.node,
    /** Text for the title icon tooltip */
    titleIconTooltipText: prop_types_1.default.string,
    /** Title of the panel */
    title: prop_types_1.default.string,
    /** Optional sub-title of the panel */
    subTitle: prop_types_1.default.string,
    /** Light or Dark theme */
    variant: prop_types_1.default.oneOf(['light', 'dark']),
    /** Display with dense layout */
    dense: prop_types_1.default.bool,
    /** Node containing icons or menu to be right aligned in header */
    headerActions: prop_types_1.default.node,
    /** Function to execute when title container is clicked */
    onTitleContainerClick: prop_types_1.default.func,
    /** Array of objects containing icon ligature and callback
     * @deprecated Use headerActions instead
     */
    actionIcons: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        /** Icon ligature */
        icon: prop_types_1.default.string.isRequired,
        /** Icon button callback */
        onClick: prop_types_1.default.func.isRequired,
    })),
    /** Array of objects containing label property and onClick property
     * @deprecated Use headerActions instead
     */
    menuOptions: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        /** Menu item label */
        label: prop_types_1.default.string.isRequired,
        /** Menu item callback */
        onClick: prop_types_1.default.func.isRequired,
    })),
    /** Child node */
    children: prop_types_1.default.node.isRequired,
    classes: prop_types_1.default.object.isRequired,
    dataTestId: prop_types_1.default.string,
    headerTestId: prop_types_1.default.string,
};
exports.UnstyledPanel.defaultProps = {
    titleIcon: null,
    titleIconTooltipText: '',
    title: null,
    subTitle: null,
    variant: 'dark',
    dense: false,
    headerActions: null,
    actionIcons: [],
    onTitleContainerClick: null,
    menuOptions: [],
    dataTestId: '',
    headerTestId: '',
};
exports.Panel = (0, styles_1.withStyles)(styles)(exports.UnstyledPanel);
exports.default = exports.Panel;
//# sourceMappingURL=index.js.map